import Cookies from 'js-cookie';

import {
  ACCESS_TOKEN_KEY,
  cookieDomain,
  IMPERSONATE_ACCESS_TOKEN_KEY,
  IMPERSONATE_REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  STORAGE_ACCESS_TOKEN_KEY,
  STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY,
  STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY,
  STORAGE_REFRESH_TOKEN_KEY,
} from './constants';

// Safari throws a SecurityError on any storage access when the user blocks it; the cookies
// must still be cleared, or sign-out stops halfway and leaves the user logged in.
const removeStorageItem = (getStorage: () => Storage, key: string) => {
  if (globalThis.window === undefined || !key) return;
  try {
    getStorage().removeItem(key);
  } catch {
    // Blocked storage holds nothing to remove.
  }
};

const removeLocalStorageToken = (key: string) => removeStorageItem(() => localStorage, key);

const removeSessionStorageToken = (key: string) => removeStorageItem(() => sessionStorage, key);

export const removeToken = (key: string) => {
  Cookies.remove(key, { domain: cookieDomain, path: '/', secure: true });

  switch (key) {
    case ACCESS_TOKEN_KEY:
      removeSessionStorageToken(STORAGE_ACCESS_TOKEN_KEY as string);
      break;
    case REFRESH_TOKEN_KEY:
      removeLocalStorageToken(STORAGE_REFRESH_TOKEN_KEY as string);
      break;
    case IMPERSONATE_ACCESS_TOKEN_KEY:
      removeSessionStorageToken(STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY as string);
      break;
    case IMPERSONATE_REFRESH_TOKEN_KEY:
      removeLocalStorageToken(STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY as string);
      break;
  }
};
